import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";
import { Link } from "gatsby";
import {
  SEOServiceskeyword,
  UnrealGameScalable,
  UnrealGameAdvanceAI,
  UnrealGameCrossPlatform,
  UnrealGameRapid,
  UnrealGameSuperior,
  UnrealGameSupport,
  UnrealGamePipeline,
} from "../../../app-constants-updated";

const WorkFlow = [
  {
    logo: GenerativeAIServiceTick,
    title: "High-Performance Optimization",
    description:
      "We provide you with a comprehensive list of targeted and niche-specific keywords best suited for your business. Our approach involves mapping these keywords to the user’s intent and trends to enhance your visibility and draw relevant traffic.",
    count: SEOServiceskeyword,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Scalable Architecture",
    description:
      "Leverage Unreal Engine’s modular and scalable architecture to future-proof your game for seamless updates and expansions without compromising performance or quality.",
    count: UnrealGameScalable,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Advanced AI Integration",
    description:
      "Implement sophisticated AI systems with Unreal Engine's powerful AI tools for better player interaction and more engaging, dynamic gameplay experiences.",
    count: UnrealGameAdvanceAI,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Cross-Platform Compatibility",
    description:
      "Unreal Engine supports development for multiple platforms, ensuring your game reaches a broader audience with consistent quality on consoles, PC, mobile, and VR devices.",
    count: UnrealGameCrossPlatform,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Rapid  & Iteration",
    description:
      "Utilize Unreal Engine’s Blueprints and real-time editing tools for fast prototyping, allowing you to test and iterate on game features quickly, reducing development time.",
    count: UnrealGameRapid,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Superior Visuals & Realism",
    description:
      "Achieve photorealistic graphics with Unreal Engine’s advanced lighting and shading capabilities, making your game visually stunning and immersive.",
    count: UnrealGameSuperior,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Comprehensive Support & Documentation",
    description:
      "Access extensive resources, including detailed documentation, community support, and expert assistance, ensuring your development process is smooth and efficient.",
    count: UnrealGameSupport,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Customizable Development Pipelines",
    description:
      "Unreal Engine game development services offer collaboration and flexible pipelines that adapt to your project’s specific needs, from concept to post-launch support.",
    count: UnrealGamePipeline,
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 nlp_process_flow search-engine-workflow worflow_seo workflow_unreal_game">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Transform <span>Gaming Experiences</span> with Unreal Engine
            </h2>
            <p>
              Experience the novel, performant benefits of partnering with our
              Unreal Engine game development company that delivers cutting-edge,
              performance-driven solutions tailored to modern gaming needs.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-3 mb-md-4">
              <div
                className="workflow_items"
                style={{ background: "#fff", pointerEvents: "none" }}
              >
                <div className="item_name">
                  <span style={{ marginBottom: "10px" }}>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
